import { Text, Tooltip } from '@ifood/pomodoro-components';
import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

export const SlugField = styled(Text)`
  display: flex;
  align-items: center;
  margin-bottom: ${tokens.space.smallest};
`;

export const TooltipContent = styled(Tooltip)`
  display: flex;
  margin-left: ${tokens.space.smaller};
`;
